import { runDemo } from "../shared/demoRunner";
import { createGlowLayerScene } from "./scene";

runDemo({ createScene: createGlowLayerScene });
